// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

// Actions
import { fetchProfile } from '../../authentication/actions';

// Assets
import './TopMenuBar.css';

// Constants
import { LEFT_PANE } from '../constants';

// Shapes
import { mapLayerShape } from '../propTypesShapes';


class TopMenuBar extends React.PureComponent {
  /* Not use withRouter and pass the location property due to
     https://github.com/ReactTraining/react-router/blob/v4.2.2/packages/
     react-router/docs/guides/blocked-updates.md */
  static propTypes = {
    token: PropTypes.string.isRequired,
    selectedMapLayer: mapLayerShape,
    history: PropTypes.object,
    location: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.handleGoBackOnClick = this.handleGoBackOnClick.bind(this);
    this.handleHomeOnClick = this.handleHomeOnClick.bind(this);
  }

  handleGoBackOnClick() {
    this.props.history.goBack();
  }

  handleHomeOnClick() {
    const { token, dispatch } = this.props;

    dispatch(fetchProfile(token));
  }

  render() {
    const { selectedMapLayer, location } = this.props;

    return (
      <div className="TopMenuBar d-flex justify-content-between align-items-center">
        <div className="d-flex">
          {location.hash !== LEFT_PANE.HASH_LINK.HOME &&
            <div className="TopMenuBarOption btn p-0" onClick={this.handleGoBackOnClick}>
              <span className="icon-back"/>
            </div>
          }

          <NavLink className="TopMenuBarOption"
            to={`${LEFT_PANE.HASH_LINK.HOME}`}
            isActive={(match, { hash, search }) =>
              hash !== LEFT_PANE.HASH_LINK.SETTINGS &&
              !(selectedMapLayer && hash === LEFT_PANE.HASH_LINK.LISTING &&
                search === LEFT_PANE.SEARCH_LINK.LISTING)
            }
            onClick={this.handleHomeOnClick}
          >
            <span className="icon-home"/>
          </NavLink>

          <NavLink className="TopMenuBarOption"
            to={`${LEFT_PANE.SEARCH_LINK.LISTING}${LEFT_PANE.HASH_LINK.LISTING}`}
            isActive={(match, location) =>
              location.hash === LEFT_PANE.HASH_LINK.LISTING &&
              location.search === LEFT_PANE.SEARCH_LINK.LISTING
            }
          >
            <span className="icon-search"/>
          </NavLink>
        </div>

        <NavLink className="TopMenuBarOption"
          to={`${LEFT_PANE.HASH_LINK.SETTINGS}`}
          isActive={(match, location) => location.hash === LEFT_PANE.HASH_LINK.SETTINGS}
        >
          <span className="icon-hamburger"/>
        </NavLink>
      </div>
    );
  }
}

export default connect(({ home }) => ({
  selectedMapLayer: home.selectedMapLayer
}), null)(TopMenuBar);
